import { ModifiedTableDataProps, ProductItemsProps } from "../interface";

export const useTableCalculation = () => {
    const modifiedTableData = ({
        data,
        isContactLens,
    }: ModifiedTableDataProps) => {
        let filterCondition = (items: ProductItemsProps) =>
            items?.product?.is_contact_lens === isContactLens;
        return data?.filter(filterCondition).length > 0
            ? [...data?.filter(filterCondition), {}]
            : [];
    };

    // function to get the value
    const getTableValue = (row: ProductItemsProps, key: string,gst_type:boolean = true):string => {
        const initialCost = row?.cost_amount / (1 - (row?.discount_percent * 0.01));
        const cost = Number(row?.cost_amount) || 0;
        const discountPercent = Number(row?.discount_percent) || 0;
        const gstPercent = gst_type ? ( row?.product?.product_type?.gst_percentage || 0) : 0;

        const discountAmount = initialCost * discountPercent * 0.01;
        const amountAfterDiscount = (initialCost - discountAmount)* Number(row?.quantity);

        switch (key) {
            case "Unit Cost Amount":
                return initialCost.toString();

            case "Discount Amount":
                return discountAmount.toFixed(2);

            case "Amount":
                return amountAfterDiscount?.toFixed(2);

            case "Total GST":
                return (amountAfterDiscount * gstPercent * 0.01)?.toFixed(2);

            case "Total Amount":
                return (amountAfterDiscount + amountAfterDiscount * gstPercent * 0.01)?.toFixed(2);

            default:
                return '';
        }
    };
    //end

    // to calculate the total
    const getTotalValue = (
        data: Array<any>,
        key: "Amount" | "Total GST" | "Total Amount",
        isContactLens: boolean,
        gst_type:boolean = true
    ): string => {
        const modifiedData = modifiedTableData({ data, isContactLens });

        const total = modifiedData.reduce((sum: number, item: any) => {
            const cost = Number(item?.cost_amount) || 0;
            const gstPercent = item?.product?.product_type?.gst_percentage || 0;

            const amountAfterDiscount = cost* item?.quantity;
            const totalGStAmount = gst_type ?  amountAfterDiscount * gstPercent * 0.01 : 0;

            let value = 0;
            
            switch (key) {
                case "Amount":
                  value = amountAfterDiscount;
                  break;
              
                case "Total GST":
                  value = totalGStAmount;
                  break;
              
                case "Total Amount":
                  value = amountAfterDiscount + totalGStAmount;
                  break;
              
                default:
                  value = 0;
                  break;
              }

            return sum + (isNaN(value) ? 0 : value);
        }, 0);

        return total.toFixed(2);
    };
    //end

    //for Total Price
    const getTotalAmount = (
        data: Array<any>,
        isContactLens: boolean
    ) => {
        let modifiedData = modifiedTableData({ data: data, isContactLens });


        return modifiedData.reduce((total: number, item: any) => {
            const cost = Number(item?.cost_amount) || 0;
            const discountPercent = Number(item?.discount_percent) || 0;
            const gstPercent = item?.product?.product_type?.gst_percentage || 0;

            const discountAmount = cost * discountPercent * 0.01;
            const amountAfterDiscount = cost - discountAmount;

            const productSRP = amountAfterDiscount + amountAfterDiscount * gstPercent * 0.01;
            if (typeof productSRP === "number" && !isNaN(productSRP)) {
                return total + productSRP;
            }
            return total;
        }, 0);
    };

    return {
        getTableValue,
        getTotalValue,
        getTotalAmount
    };
};
